import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mantangApi as api } from '@/shared/api';
import { MESSAGE } from '@/shared/consts';
import { favoritesKeys } from '../api/favorites.keys';

const useSaveStation = (stationId: string) => {
	const { data: isSaved = false } = useQuery({
		queryFn: () => api.checkIsSavedGasStation(stationId),
		queryKey: favoritesKeys.detail(stationId),
	});

	const { mutate: toggleSave } = useMutation<
		boolean,
		Error,
		void,
		{ isSaved: boolean }
	>({
		mutationFn: () => api.toggleSavedGasStation(stationId),
		onSuccess: (nextIsSaved) => {
			if (nextIsSaved) {
				toast.success(MESSAGE.SUCCESS.FAVORITE_ADDED);
				return;
			}

			toast.success(MESSAGE.SUCCESS.FAVORITE_REMOVED);
		},
		onError: (_, __, snapshot, context) => {
			context.client.setQueryData(
				favoritesKeys.detail(stationId),
				snapshot?.isSaved ?? false,
			);
			toast.error(MESSAGE.ERROR.RETRY);
		},
		onSettled: (_, __, ___, ____, context) => {
			context.client.invalidateQueries({ queryKey: favoritesKeys.all });
		},
		onMutate: async (_, context) => {
			await context.client.cancelQueries({
				queryKey: favoritesKeys.detail(stationId),
			});

			const isSaved =
				context.client.getQueryData<boolean>(favoritesKeys.detail(stationId)) ??
				false;

			context.client.setQueryData(favoritesKeys.detail(stationId), !isSaved);

			return { isSaved };
		},
	});

	return {
		isSaved,
		toggleSave,
	};
};

export default useSaveStation;
